// extracted by mini-css-extract-plugin
export var actionButton = "_b4-1";
export var actionButtons = "_b4-2";
export var actions = "_b4-0";
export var aiUnread = "_b4-10";
export var alignCenter = "_b4-h";
export var backWrapper = "_b4-3";
export var cellContainer = "_b4-4";
export var checkboxContainer = "_b4-5";
export var contentContainer = "_b4-6";
export var contentHeader = "_b4-8";
export var conversationsTableWrapper = "_b4-s";
export var draftReplyBadgeContainer = "_b4-m";
export var dropdownItem = "_b4-b";
export var dropdownItemsContainer = "_b4-a";
export var dropdownTitle = "_b4-c";
export var errorIcon = "_b4-7";
export var filter = "_b4-d";
export var gray = "_b4-i";
export var headerActionButtons = "_b4-e";
export var headerCheckboxContainer = "_b4-f";
export var icon = "_b4-j";
export var menuContainer = "_b4-k";
export var noMoreTicketsIcon = "_b4-12";
export var noMoreTicketsSubText = "_b4-13";
export var oneLine = "_b4-l";
export var optionsButton = "_b4-n";
export var plus = "_b4-o";
export var portalButtonsWrapper = "_b4-g";
export var red = "_b4-p";
export var scrolledTop = "_b4-9";
export var search = "_b4-q";
export var selectedConversationsCount = "_b4-r";
export var spinner = "_b4-t";
export var strong = "_b4-u";
export var summaryCell = "_b4-v";
export var tableContainer = "_b4-11";
export var tagContainer = "_b4-w";
export var threeDots = "_b4-x";
export var twoLines = "_b4-y";
export var unread = "_b4-z";